import { ErrorBase } from '~/utils/error-base';

type ErrorName =
  | 'CAPTCHA_REQUIRED'
  | 'CHARGE_FAILED'
  | 'CHECKOUT_TRANSFORM_FAILED'
  | 'COUNTRY_BLOCK'
  | 'INCOMPLETE_CLIENT_ACTION'
  | 'INVALID_FREE_TRIAL_PAYMENT_METHOD';

export class CheckoutError extends ErrorBase<ErrorName> {}
